import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MobileHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="fixed bottom-3 left-2 right-2 sm:left-4 sm:right-4 md:hidden z-[9999]">
      <div className="flex rounded-2xl mx-auto nav-tabs-3d backdrop-blur-xl justify-evenly items-center border border-dexora-dark-tertiary/50 shadow-[0_-4px_24px_rgba(0,0,0,0.3)] p-1 sm:p-1.5">
        {[
          { label: "Swap", path: "/", isActive: pathname === "/" },
          { label: "Bridge", path: "/bridge", isActive: pathname.startsWith("/bridge") },
          { label: "Trade", path: "https://www.dexora.exchange/trade/BTC", isActive: false, external: true },
          { label: "Prediction", path: "https://predict.dexora.live/", isActive: false, external: true },
          { label: "Pools", path: "/pool", isActive: pathname.startsWith("/pool") || pathname.includes("/remove") },
          { label: "Dexorbit", path: "https://dexora.live/", isActive: false, external: true },
        ].map((tab) => (
          <button
            key={tab.label}
            onClick={() => tab.external ? window.open(tab.path, '_blank') : navigate(tab.path)}
            className={`flex-1 min-w-0 rounded-xl py-2.5 text-[10px] sm:text-[13px] font-bold transition-all duration-300 ${
              tab.isActive
                ? "nav-tab-active"
                : "text-dexora-text-muted"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileHeader;
